import {Autocomplete, FormControl, FormLabel, TextField} from '@mui/material';
import React from 'react';

type AutoCompleteProps = {
  title?: string;
  placeholder?: string;
  data: Array<string>;
  defaultValue?: string;
  size?: 'small' | 'medium';
  changeCallback?: (arg0: string) => void;
  required?: boolean;
};

//Single select Type String<Array> --- Multiple Select Type Array<label: string, value: string>
const AutoCompleteSelector = ({
  title,
  placeholder,
  data,
  changeCallback,
  defaultValue,
  size = 'small',
  required = false,
}: AutoCompleteProps) => {
  const [value, setValue] = React.useState<string | undefined>(defaultValue);
  const [inputValue, setInputValue] = React.useState(defaultValue);
  return (
    <FormControl sx={{maxHeight: 60, minWidth: 300}} required={required}>
      <FormLabel sx={{color: 'black', fontWeight: 600, mb: 0.5}}>{title}</FormLabel>
      {data && (
        <Autocomplete
          value={value}
          onChange={(event, newValue: string | null) => {
            if (event && newValue !== null && newValue !== '') {
              setValue(newValue);
              if (newValue && changeCallback) {
                changeCallback(newValue);
              }
            } else if (newValue === null || newValue === '') {
              setValue('');
              setInputValue('');
              changeCallback && changeCallback('');
            }
          }}
          inputValue={inputValue}
          onInputChange={(event, newInputValue) => {
            if (event) setInputValue(newInputValue);
          }}
          size={size}
          disabled={data?.length && data.length > 0 ? false : true}
          sx={{width: '100%', '.MuiInputBase-root': {minHeight: '40px'}}}
          defaultValue={defaultValue}
          options={data}
          renderInput={(params) => (
            <FormControl sx={{width: '100%'}}>
              <TextField
                {...params}
                placeholder={data?.length && data.length > 0 ? placeholder : ''}
                size='small'
                variant='outlined'
              />
            </FormControl>
          )}
        />
      )}
    </FormControl>
  );
};
export default AutoCompleteSelector;
